// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"6d54c5c3","496":"776d1f54","515":"0d53a39f","518":"ab1edae8","860":"0a9fd963"}[chunkId] + ".chunk.js";
};